import type { ReactNode } from "react";

type Props = {
	/** Accessible / tooltip title. */
	title: string;
	children?: ReactNode;
	className?: string;
};

/**
 * Small corner-anchored accent mark (generalizes Worthy Human).
 * Keep tiny — never compete with primary actions.
 * `shadow-sm` is intentional: corner elevation on the canonical mark (not variant-flat).
 */
export function TrustBadge({ title, children, className = "" }: Props) {
	return (
		<span
			className={[
				"inline-flex items-center justify-center rounded-full border border-wi-gold/45 bg-wi-surface/95 p-0.5 shadow-sm",
				className,
			]
				.filter(Boolean)
				.join(" ")}
			title={title}
		>
			{children ?? (
				<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden className="text-wi-gold">
					<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.2" />
					<circle cx="12" cy="12" r="3.2" fill="currentColor" />
				</svg>
			)}
		</span>
	);
}
